module.exports = __webpack_public_path__ + "static/media/video-plus.d41da47b.svg";